import { Api, type RequestParams } from '@sdk/Api'
import { Api as StorageApi } from '@sdk/Storage'
import type { Auth } from 'firebase/auth'

export function createApiParams(
	auth: Auth,
	tenantId?: string,
): void | RequestParams | Promise<void | RequestParams> {
	const defaultRequestParams: RequestParams = {
		headers: tenantId ? { 'X-Tenant-Id': tenantId } : {},
		cache: 'no-cache',
	}

	if (!auth.currentUser) {
		return defaultRequestParams
	}

	return auth.currentUser.getIdToken().then((token) => ({
		...defaultRequestParams,
		headers: {
			Authorization: `Bearer ${token}`,
			...defaultRequestParams.headers,
		},
	}))
}

export function createApiBasePath(basePath: string) {
	return basePath
}

export function createApi(basePath: string, auth: Auth, tenantId?: string) {
	const api = new Api<Auth>({
		securityWorker: (auth) => createApiParams(auth, tenantId),
		baseUrl: createApiBasePath(basePath),
		baseApiParams: {
			secure: true,
		},
	})
	api.setSecurityData(auth)
	return api
}
export function createStorageApi(basePath: string, auth: Auth, tenantId?: string) {
	const api = new StorageApi<Auth>({
		securityWorker: (auth) => createApiParams(auth, tenantId),
		baseUrl: createApiBasePath(basePath),
		baseApiParams: {
			secure: true,
		},
	})
	api.setSecurityData(auth)
	return api
}
